import { apiClient } from "./client";
import type {
  DismissReason,
  AppointmentInfo,
  AuditRunResponse,
  AuditReport,
  LeakageSummary,
  FlagStatus,
  Severity,
} from "@/types";

export async function runAudit(appointmentId: string): Promise<AuditRunResponse> {
  const { data } = await apiClient.post<AuditRunResponse>(
    `/api/v1/audit/run/${appointmentId}`,
  );
  return data;
}

export async function getAuditReport(
  appointmentId: string,
  severityFilter?: Severity,
): Promise<AuditReport> {
  const { data } = await apiClient.get<AuditReport>(
    `/api/v1/audit/report/${appointmentId}`,
    { params: severityFilter ? { severity_filter: severityFilter } : {} },
  );
  return data;
}

/** Dismissing needs a reason; "other" also needs notes (the API rejects it otherwise). */
export async function updateFlagStatus(
  flagId: string,
  status: FlagStatus,
  opts: { reason?: DismissReason; notes?: string } = {},
): Promise<void> {
  await apiClient.patch(`/api/v1/audit/flags/${flagId}`, { status, ...opts });
}

export async function listAppointments(limit = 50, offset = 0): Promise<AppointmentInfo[]> {
  const { data } = await apiClient.get<AppointmentInfo[]>("/api/v1/audit/appointments", {
    params: { limit, offset },
  });
  return data;
}

export async function getLeakageSummary(clinicId: string): Promise<LeakageSummary> {
  const { data } = await apiClient.get<LeakageSummary>(
    `/api/v1/audit/leakage-summary/${clinicId}`,
  );
  return data;
}

export interface LlmConfig {
  llm_provider: "anthropic" | "openai" | "gemini";
  model: string;
}

export async function getLlmConfig(): Promise<LlmConfig> {
  const { data } = await apiClient.get<LlmConfig>("/health/config");
  return data;
}
